import { ListSortDirection, Sort } from "../../models/api/sort";
import { DocumentStatusDTO, DocumentStatusSTO } from "../../models/documents/document-statuses";

import { BaseApiService } from "../base/base-api.service";

export class DocumentStatusesApiService extends BaseApiService<DocumentStatusDTO, DocumentStatusSTO> {
  constructor() {
    super({
      servicePath: "/DocumentStatuses",
      loadItemsPath: "/GetDocumentStatuses",
      saveItemsPath: "/SaveDocumentStatuses",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
